export default "__VITE_ASSET__CVsangYd__"